import { LOCAL_STORAGE_TIME_TO_LIVE } from "const";

interface ITimeLimitedStorageItem {
  value: string;
  expiry: number;
}

export const saveToTimedLocalStorage = (key: string, value?: string, expiry?: number) => {
  if (value === undefined) {
    window.localStorage.removeItem(key);
    return;
  }

  const now = new Date();
  const storageItem: ITimeLimitedStorageItem = {
    value,
    expiry: expiry ?? now.getTime() + LOCAL_STORAGE_TIME_TO_LIVE,
  };

  window.localStorage.setItem(key, JSON.stringify(storageItem));
};

export const getFromTimedLocalStorage = (key: string) => {
  const data = window.localStorage.getItem(key);

  if (data === null) {
    window.localStorage.removeItem(key);
    return null;
  }

  const parsedData: ITimeLimitedStorageItem = JSON.parse(data);
  const now = new Date();

  if (now.getTime() > parsedData.expiry) {
    window.localStorage.removeItem(key);
    return null;
  }

  return parsedData.value;
};

export const saveToLocalStorage = (key: string, value?: any) => {
  if (value === undefined) {
    window.localStorage.removeItem(key);
    return;
  }

  window.localStorage.setItem(key, JSON.stringify(value));
};

// AIDEV-NOTE: `JSON.parse` tady drive nebyl osetreny, takze jedina poskozena polozka
// (rucne prepsany token, zbytek po zmene formatu, zasah jineho nastroje) vyhodila vyjimku
// pri cteni a aplikace zustala viset na „Loading…" s prazdnou konzoli. Nevalidni hodnotu
// radeji zahodime a tvarime se, ze tam nic nebylo — uzivatel se znovu prihlasi, misto aby
// koukal na bilou stranku.
export const getFromLocalStorage = <T>(key: string) => {
  const value = window.localStorage.getItem(key);

  if (typeof value === "string") {
    try {
      return JSON.parse(value) as T;
    } catch {
      window.localStorage.removeItem(key);
      return null;
    }
  }

  window.localStorage.removeItem(key);
  return null;
};
